module.exports = __webpack_public_path__ + "img/2.6_About-Us_Key-Partner_1_NHMRC.4d9de8551709eba05fa602fd8177eaf1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.6_About-Us_Key-Partner_1_NHMRC.svg
// module id = 778
// module chunks = 0